import React from 'react';
import { ListItem } from '@material-ui/core';

const ListItemLink = React.forwardRef(({ children, ...props }, ref) => (
	<ListItem button component="a" {...props} ref={ref}>
		{children}
	</ListItem>
));

export default ListItemLink;